// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".theme-white[data-v-023d4d4e] .icon svg{fill:#fff}.toggle-search[data-v-023d4d4e]{display:inline-flex;position:relative;z-index:1;cursor:pointer}.icon.size-m[data-v-023d4d4e]{width:1.25rem;max-height:1.25rem}.icon.size-m[data-v-023d4d4e] svg{width:1.25rem;max-height:1.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
